<script setup>
import { RouterLink } from 'vue-router';
import LucideIcon from '@/components/ui/LucideIcon.vue';
import WhatsAppIcon from '@/components/ui/WhatsAppIcon.vue';
import InstagramIcon from '@/components/ui/InstagramIcon.vue';
import logoMark from '@/assets/brand/logo-mark.png';

const WHATSAPP = 'https://wa.me/2348108409907';
const INSTAGRAM = 'https://www.instagram.com/goodmorning_toursandsafari?igsh=czZzcXVwYmNreHVj&utm_source=qr';
</script>

<template>
  <footer class="footer" id="contact">
    <div class="wrap">
      <div class="footer__top">
        <div class="footer__brand">
          <img :src="logoMark" alt="Good Morning Tours & Safari" />
          <p>Crafted safaris, cultural journeys, mountain treks and beach escapes across Tanzania — guided by people who call this land home.</p>
          <p class="footer__tagline">“The best is yet to come.”</p>
        </div>
        <div class="footer__col">
          <h4>Explore</h4>
          <ul>
            <li><router-link :to="{ path: '/', hash: '#destinations' }">Destinations</router-link></li>
            <li><router-link :to="{ path: '/', hash: '#tour-packages' }">Tour Packages</router-link></li>
            <li><router-link :to="{ path: '/', hash: '#categories' }">Tour Categories</router-link></li>
            <li><router-link :to="{ path: '/', hash: '#destinations' }">Gallery</router-link></li>
            <li><router-link :to="{ name: 'blog' }">Blog</router-link></li>
          </ul>
        </div>
        <div class="footer__col">
          <h4>Company</h4>
          <ul>
            <li><router-link :to="{ name: 'about' }">About Us</router-link></li>
            <li><router-link :to="{ path: '/', hash: '#testimonials' }">Testimonials</router-link></li>
            <li><a href="#">Our Team</a></li>
            <li><a href="#">Responsible Travel</a></li>
            <li><router-link :to="{ name: 'contact' }">Contact</router-link></li>
          </ul>
        </div>
        <div class="footer__col">
          <h4>Get In Touch</h4>
          <ul class="footer__contact">
            <li class="ic"><LucideIcon name="map-pin" :size="16" /><span>Middleton Road, Arusha, Tanzania</span></li>
            <li class="ic"><LucideIcon name="phone" :size="16" /><a href="tel:+2348108409907">+234 810 840 9907</a></li>
            <li class="ic"><LucideIcon name="mail" :size="16" /><a href="mailto:info@goodmorningtoursandsafari.com">info@goodmorningtoursandsafari.com</a></li>
            <li class="ic"><LucideIcon name="globe" :size="16" /><a href="#">goodmorningtoursandsafari.com</a></li>
          </ul>
          <div class="footer__social">
            <a :href="WHATSAPP" target="_blank" rel="noreferrer" aria-label="Chat on WhatsApp"><WhatsAppIcon :size="18" /></a>
            <a :href="INSTAGRAM" target="_blank" rel="noreferrer" aria-label="Follow us on Instagram"><InstagramIcon :size="18" /></a>
          </div>
        </div>
      </div>
      <div class="footer__bottom">
        <span>© 2026 Good Morning Tours &amp; Safari. Licensed Tour Operator · Arusha, Tanzania.</span>
        <span>Privacy · Terms · Sitemap</span>
      </div>
    </div>
  </footer>
</template>
